export default class User {

    constructor(jsonResponse) {

        this.id = jsonResponse["id"];
        this.credentialId = jsonResponse["credential-id"];
        this.organisationId = jsonResponse["organisation-id"];
        this.firstName = jsonResponse["first-name"];
        this.lastName = jsonResponse["last-name"];
        this.agentCode = jsonResponse["agent-code"];
        this.idNumber = jsonResponse["id-number"];
        this.nationality = jsonResponse["nationality"];
        this.cellphoneNumber = jsonResponse["cellphone-number"];
        this.altCellphoneNumber = jsonResponse["alt-cellphone-number"];
        this.email = jsonResponse["email"];
        this.streetNumber = jsonResponse["street-number"];
        this.streetName = jsonResponse["street-name"];
        this.buildingName = jsonResponse["building-name"];
        this.suburb = jsonResponse["suburb"];
        this.city = jsonResponse["city"];
        this.province = jsonResponse["province"];
        this.active = jsonResponse["active"];
        this.deleted = jsonResponse["deleted"];

        this.fullName = this.firstName + " " + this.lastName;
    }

    static toJson = function (item) {

        let jsonObj = {};
        jsonObj["id"] = item.id;
        jsonObj["credential-id"] = item.credentialId;
        jsonObj["organisation-id"] = item.organisationId;
        jsonObj["first-name"] = item.firstName;
        jsonObj["last-name"] = item.lastName;
        jsonObj["agent-code"] = item.agentCode;
        jsonObj["id-number"] = item.idNumber;
        jsonObj["nationality"] = item.nationality;
        jsonObj["cellphone-number"] = item.cellphoneNumber;
        jsonObj["alt-cellphone-number"] = item.altCellphoneNumber;
        jsonObj["email"] = item.email;
        jsonObj["street-number"] = item.streetNumber;
        jsonObj["street-name"] = item.streetName;
        jsonObj["building-name"] = item.buildingName;
        jsonObj["suburb"] = item.suburb;
        jsonObj["city"] = item.city;
        jsonObj["province"] = item.province;
        jsonObj["active"] = item.active;
        jsonObj["deleted"] = item.deleted;

        return jsonObj;
    };
}
